import {OpportunityStatistics} from "../model/OpportunityStatistics";
import {CalculatorName} from "../../calculations/model/Calculator";


export interface ParsedStatistics {
    labels: string[];
    datasets: any;
}

export class OpportunityStatisticsBuilder {

    constructor(private statistics: OpportunityStatistics[]) {
    }

    static calculationsLablesMap: { [calculationName: string]: string } = {
        "SAVINGS": "Savings",
        "RATE_CALCULATOR": "Rate Reduction",
        "EQUITY_CASH_OUT": "Cash Out",
        "EQUITY_RATE_AND_TERM_REFINANCE": "Equity Growth",
        "TRIGGER_LEADS": "Trigger Leads"
    };

    static calculationsColorsMap: { [calculationName: string]: string } = {
        "SAVINGS": "#FD8976",
        "RATE_CALCULATOR": "#A575C6",
        "EQUITY_CASH_OUT": "#28C5EA",
        "EQUITY_RATE_AND_TERM_REFINANCE": "#EFDF6A",
        "TRIGGER_LEADS": "#94df22"
    };

    public buildForDates(from: Date, to: Date): ParsedStatistics {
        let labels: string[] = [];
        let allDatasets = this.initalizeDatasets();
        for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
            labels.push(this.dateString(d));
            for (let calculatorName of Object.values(CalculatorName)) {
                let res: OpportunityStatistics = this.findStatisticsForDate(d, calculatorName);
                let oppCount = this.getOpportunityCount(res);
                allDatasets[[calculatorName, false].toString()].data.push(oppCount);
            }
        }
        return {datasets: Object.values(allDatasets), labels: labels};
    }


    private initalizeDatasets() {
        let allDatasets: any = {};
        for (let calculatorName of Object.values(CalculatorName)) {
            let dataset = this.createOpportunitiesDataset(calculatorName);
            allDatasets[[calculatorName, false].toString()] = (dataset);
        }
        return allDatasets;
    }

    private createOpportunitiesDataset(calculatorName) {
        let dataset: any = {};
        dataset.data = [];
        dataset.stack = 'Opportunities Stack';
        dataset.label = OpportunityStatisticsBuilder.calculationsLablesMap[calculatorName];
        dataset.backgroundColor = OpportunityStatisticsBuilder.calculationsColorsMap[calculatorName];
        return dataset;
    }

    public getOpportunityCount(res: OpportunityStatistics): number {
        if (res != undefined) {
            return res.count;
        } else {
            return 0;
        }
    }


    private findStatisticsForDate(date: Date, calcName: CalculatorName): OpportunityStatistics | undefined {
        return this.statistics.find((s) => this.equalDate(new Date(s.date), date) && s.calculatorName == calcName);
    }

    public dateString(date: Date) {
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
    }

    public equalDate(dateOne: Date, dateTwo: Date) {
        return dateOne.getFullYear() === dateTwo.getFullYear() &&
            dateOne.getMonth() === dateTwo.getMonth() &&
            dateOne.getDate() === dateTwo.getDate();
    }

}